import { moduleProviderFactory } from 'core/providers';
import { UserList, UserEdit, UserCreate, UserPreview, UserProfileEdit } from 'application/user/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.user',
                pattern: '/users',
                children: [
                    {
                        name: 'master.app.main.user.list',
                        pattern: '',
                        tabTitle: "USER.LIST.TITLE",
                        component: UserList,
                        authorization: 'administrationSection.read',
                        data: {
                            title: "USER.LIST.TITLE"
                        }
                    },                    
                    {
                        name: 'master.app.main.user.create',
                        pattern: '/create',
                        tabTitle: "Create User",
                        component: UserCreate,
                        authorization: 'administrationSection.create',
                        data: {
                            title: "Create"
                        }
                    },
                    {
                        name: 'master.app.main.user.edit',
                        pattern: '/edit/:id',
                        tabTitle: "Edit User",
                        component: UserEdit,
                        authorization: 'administrationSection.update',
                        data: {
                            title: "USER.EDIT.TITLE"
                        }
                    },
                    {
                        name: 'master.app.main.user.preview',
                        pattern: '/preview/:id',
                        tabTitle: "User Preview",
                        component: UserPreview,
                        authorization: 'administrationSection.read',
                        data: {
                            title: "USER.PREVIEW.TITLE"
                        }
                    }
                ]
            },
            {
                name: 'master.app.main.my-profile',
                pattern: '/my-profile/:id',
                tabTitle: 'My Profile',
                component: UserProfileEdit,
                // authorization: 'administrationSection.read',
                data: {
                    title: "USER.PROFILE.TITLE"
                }
            }
        ],
        menu : [
        {
            title: 'MENU.ADMINISTRATION',
            order: 10,
            icon: 'users',
            authorization: 'administrationSection.read',
            subMenu: [
                {
                    title: 'MENU.USERS',
                    icon: 'users',
                    route: 'master.app.main.user.list',
                    order: 1,
                    authorization: 'administrationSection.read',
                }                    
            ]
        }
        ]
    });
})();
